import { RoleModel } from './role.model';

export class UserModel {
  id = 0;
  externalUserId = '';
  deleted = false;
  lastChangedPassword: Date = new Date();
  password = '';
  title = '';
  firstName = '';
  lastName = '';
  username = '';
  jobTitle = '';
  printer = 'Dummy printer';
  roleId = 1;
  role: RoleModel = new RoleModel();
  roles: RoleModel[] = [
    {
      id: 1,
      name: 'User',
    },
    {
      id: 2,
      name: 'Team leader',
    },
    {
      id: 3,
      name: 'Manager',
    },
  ];
  teamLeader: number = null;
  adminAccess: boolean = null;
  reportsAccess: boolean = null;
  editLetter = false;
  factoryUsed = '';
  acceptedTerms = true;
  isAccountLocked = false;
  isActivated = true;
  confirmPassword = '';
  changeDecision: string = null;
  emailAddress = '';
  signatureId: number;
  contactEmailAddress: string = null;
}
